export default __webpack_public_path__ + "static/media/pour-cocktail.6f7915b3.jpg";